const stagingDeployment = 'AKfycby8MYE_T_UAPrPR3WxBhu_6A0cizWTvql2Nmrq5_82TXyxBJJlhz0lP3mDgR-6FclTx';
const productionDeployment = 'AKfycby8MYE_T_UAPrPR3WxBhu_6A0cizWTvql2Nmrq5_82TXyxBJJlhz0lP3mDgR-6FclTx';

export const stagingEndpoint = getGoogleApiUrl(stagingDeployment);
export const productionEndpoint = getGoogleApiUrl(productionDeployment);

function getGoogleApiUrl(deploymentId: string): string {
  return `https://script.google.com/macros/s/${deploymentId}/exec`;
}
